import React from 'react';
import t from '@jetshop/intl';
import { cx, css } from 'linaria';
import { ElevateAutocompleteProductCard } from './ElevateAutocompleteProductCard';
import { elevateAutocompleteTitleStyle } from './ElevateAutocompleteTitleStyle';

const searchProductSuggestionsStyle = css`
  .search-product-suggestions-presenter {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    row-gap: 16px;
    width: 100%;
  }
`;

export const ElevateProductSuggestions = ({
  productGroups,
  title,
  clickCallback
}) => {
  return (
    <div
      className={cx(
        'search-product-suggestions search-result-section',
        searchProductSuggestionsStyle
      )}
    >
      <h2 className={elevateAutocompleteTitleStyle}>{t(title)}</h2>
      <ul className="search-product-suggestions-presenter">
        {productGroups?.map(productGroup => {
          return (
            <ElevateAutocompleteProductCard
              key={productGroup?.key}
              productGroup={productGroup}
              clickCallback={clickCallback}
              imageAspect="64:80"
            />
          );
        })}
      </ul>
    </div>
  );
};
